import React, { useState } from 'react';
import {
  Drawer,
  Tabs,
  Tab,
  Button,
  RadioGroup,
  Radio,
  FormControlLabel,
  Typography,
  Card,
  CardContent,
  Box,
  Divider,
  useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/system';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import './BillingPopup.css';

const currencySymbols = {
  "₹ Rupee": "₹",
  "$ Usd": "$",
  "£ Pound": "£",
  "€ Euro": "€"
};

const currencyRates = {
  "₹ Rupee": 1,
  "$ Usd": 0.012,
  "£ Pound": 0.009,
  "€ Euro": 0.011
};

const basePackageOptions = [
  { label: "200 Agents", amount: 1000 },
  { label: "API Integration", amount: 500 },
  { label: "Exclusive Users", amount: 700 },
  { label: "14 Images per Case", amount: 300 }
];

const addOnsOptions = [
  { label: "Tyre", amount: 400 },
  { label: "360 Views", amount: 600 }
];

const BillingPopup = ({ open, onClose, onSubmit, handleImage, file }) => {
  const [currency, setCurrency] = useState('₹ Rupee');
  const [billingType, setBillingType] = useState('Pre Paid');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const convertedBaseAmount = basePackageOptions.reduce((total, option) => {
    return total + option.amount * currencyRates[currency];
  }, 0).toFixed(2);

  const convertedAddOnsAmount = addOnsOptions.reduce((total, option) => {
    return total + option.amount * currencyRates[currency];
  }, 0).toFixed(2);

  const totalAmount = (parseFloat(convertedBaseAmount) + parseFloat(convertedAddOnsAmount)).toFixed(2);

  const handleCurrencyChange = (event, newValue) => {
    setCurrency(newValue);
  };

  const handleAddOrganisationClick = () => {
    if (onSubmit) {
      onSubmit();
    }
    if (handleImage) {
      console.log("31", file);

      handleImage({ FileList: file ? [file] : [] });
    }
    onClose();
  };

 
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: isMobile ? '100%' : '500px', height: '100vh', display: 'flex', flexDirection: 'column' }
      }}
    >
      <div className="drawer-header" style={{ padding: '8px 16px', position: 'relative' }}>
        <Typography>Billing</Typography>
        <Button onClick={onClose} style={{ position: 'absolute', top: '-1px', left: '-50px', backgroundColor: '#fff', borderRadius: '50%', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)', minWidth: '40px', height: '40px', padding: '8px', zIndex: 1 }}>
          <CloseIcon style={{ color: 'black' }} />
        </Button>
      </div>

      <div style={{ flex: 1, padding: '8px 16px', overflowY: 'auto' }}>
        <Tabs
          value={currency}
          onChange={handleCurrencyChange}
          variant="scrollable"
          scrollButtons="auto"
          TabIndicatorProps={{ style: { display: 'none' } }}
          sx={{ borderRadius: '16px', overflow: 'hidden', backgroundColor: '#f1f1f1', border: '1px solid #d1d1d1', minHeight: '36px' }}
        >
          {Object.keys(currencySymbols).map((curr) => (
            <Tab
              key={curr}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {currency === curr && <CheckIcon fontSize="small" sx={{ marginRight: '4px' }} />}
                  {curr}
                </Box>
              }
              value={curr}
            />
          ))}
        </Tabs>

        <RadioGroup value={billingType} onChange={(e) => setBillingType(e.target.value)} style={{ marginTop: '8px' }}>
          {["Pre Paid", "Post Paid", "Credit"].map((type) => (
            <FormControlLabel
              key={type}
              value={type}
              control={<Radio sx={{ color: billingType === type ? '#ff0083' : 'black', '&.Mui-checked': { color: '#ff0083' } }} />}
              label={type}
            />
          ))}
        </RadioGroup>

        <Card variant="outlined" style={{ marginTop: '8px', padding: '16px',fontWeight: 'bold' }}>
          <CardContent>
            <Typography>Base Package</Typography>
            {basePackageOptions.map((option, index) => (
              <Typography key={index} style={{ marginTop: '4px' }}>
                {option.label} - {currencySymbols[currency]} {(option.amount * currencyRates[currency]).toFixed(2)}
              </Typography>
            ))}
            <Divider style={{ margin: '8px 0', fontWeight: 'bold' }} />
            <Typography align="right">Total: {currencySymbols[currency]} {convertedBaseAmount}</Typography>
          </CardContent>
        </Card>

        <Card variant="outlined" style={{ marginTop: '8px', padding: '16px' ,fontWeight: 'bold' }}>
          <CardContent>
            <Typography>Add Ons</Typography>
            {addOnsOptions.map((option, index) => (
              <Typography key={index} style={{ marginTop: '4px' }}>
                {option.label} - {currencySymbols[currency]} {(option.amount * currencyRates[currency]).toFixed(2)}
              </Typography>
            ))}
            <Divider style={{ margin: '8px 0', fontWeight: 'bold'}} />
            <Typography align="right">Total: {currencySymbols[currency]} {convertedAddOnsAmount}</Typography>
          </CardContent>
        </Card>
      </div>  

      <div style={{ padding: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontWeight: 'bold' }}>
        <Typography>Grand Total: {currencySymbols[currency]} {totalAmount}</Typography>
        <div>
          <Button style={{ backgroundColor: '#ff0083', color: 'white', marginRight: '8px' }} onClick={handleAddOrganisationClick}>
            Add Organisation
          </Button>
          <Button onClick={onClose} style={{ color: '#ff0083' }}>
            Close
          </Button>
        </div>
      </div>
    </Drawer>
  );

};

export default BillingPopup;